import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidate } from '@refinedev/core'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { ordersPatchReturnApprovalMutation } from '@repo/sdk'

import { useInvalidateFulfillmentOrders } from '../orders/useInvalidateFulfillmentOrders'

export function useApproveReturn() {
  const invalidate = useInvalidate()
  const queryClient = useQueryClient()
  const invalidateFulfillmentOrders = useInvalidateFulfillmentOrders()
  const { message } = App.useApp()
  const { t } = useTranslation()
  const [isInvalidating, setIsInvalidating] = useState(false)

  const { mutate, isPending } = useMutation({
    ...ordersPatchReturnApprovalMutation(),
    onSuccess: async (_data, variables) => {
      message.success(t('common.modals.approveReturnSuccess'))
      setIsInvalidating(true)
      await Promise.all([
        // `detail` only matches when the id is supplied — without it the detail stays stale.
        invalidate({
          resource: 'return-list',
          invalidates: ['list', 'detail'],
          id: variables.path?.returnId,
        }),
        queryClient.invalidateQueries({ queryKey: ['returnTabCounts'] }),
        // The order/FO status in 판매내역 changes with the approval.
        invalidateFulfillmentOrders(),
      ])
      setIsInvalidating(false)
    },
    onError: () => {
      message.error(t('common.modals.approveReturnFailed'))
    },
  })

  const approveReturn = (returnId: string) => {
    mutate({ path: { returnId } })
  }

  return { approveReturn, isApproving: isPending || isInvalidating }
}
